/* eslint-disable no-return-assign */
/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useCallback } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Form,
  Modal,
} from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import axios from '../../services/axios';
import Breadcrumbs from '../../components/Breadcrumbs';
import PageHeader from '../../components/PageHeader';
import Loading from '../../components/Loading';
import ErrorProcessor from '../../components/ErrorProcessor';
import DataTable from '../../components/DataTable';
import { exportToExcel } from '../../utils/exportUtils';

export default function Relatorios() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState(null);
  const [data, setData] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [serviceDesks, setServiceDesks] = useState([]);
  const [filterType, setFilterType] = useState('tickets'); // Default filter type
  const [dateRange, setDateRange] = useState({
    start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD'),
  });
  // Adicione o estado para o filtro de status
  const [statusFilter, setStatusFilter] = useState('');
  // Novos estados para os relatórios avançados
  const [clientsData, setClientsData] = useState([]);
  const [attendantsData, setAttendantsData] = useState([]);
  const [ticketsData, setTicketsData] = useState([]);
  const [selectedAttendant, setSelectedAttendant] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedServiceDesk, setSelectedServiceDesk] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [customers, setCustomers] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [reportType] = useState('tickets'); // Can be tickets | atendidos

  // Função auxiliar para obter o label do tipo de filtro
  const getFilterTypeLabel = (type) => {
    switch (type) {
      case 'departamentos':
        return 'Departamentos';
      case 'atendentes':
        return 'Atendentes';
      case 'servicedesk':
        return 'Mesa de Serviço';
      case 'stageid':
        return 'Estágios';
      default:
        return 'Tickets';
    }
  };

  // Função para buscar dados auxiliares (Perfis e Service Desks)
  const fetchAuxiliaryData = useCallback(async () => {
    try {
      // Fazer requisições individuais para melhor tratamento de erro
      let profilesData = [];
      let serviceDesksData = [];
      let departmentsData = [];

      try {
        const profilesResponse = await axios.get('/profiles');
        profilesData = profilesResponse.data;
      } catch (err) {
        console.error('Erro ao carregar perfis:', err);
      }

      try {
        const serviceDesksResponse = await axios.get('/servicedesks');
        serviceDesksData = serviceDesksResponse.data;
      } catch (err) {
        console.error('Erro ao carregar mesas de serviço:', err);
      }

      try {
        const departmentsResponse = await axios.get('/departaments');
        departmentsData = departmentsResponse.data;
      } catch (err) {
        console.error('Erro ao carregar departamentos:', err);
      }

      let customersData = [];
      try {
        const customersResponse = await axios.get('/customers/list');
        customersData = customersResponse.data;
      } catch (err) {
        console.error('Erro ao carregar clientes:', err);
      }

      console.log('Dados auxiliares carregados:', {
        profiles: profilesData ? profilesData.length : 0,
        serviceDesks: serviceDesksData ? serviceDesksData.length : 0,
        departments: departmentsData ? departmentsData.length : 0,
        customers: customersData ? customersData.length : 0,
      });

      setProfiles(profilesData);
      setServiceDesks(serviceDesksData);
      setDepartments(departmentsData);
      setCustomers(customersData);
    } catch (err) {
      console.error('Erro geral ao carregar dados auxiliares:', err);
      setApiErrors(err);
    }
  }, []);

  // Função para buscar relatório de clientes por mesa de serviço
  const fetchClientsReport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.get('/relatorios/clients-by-servicedesk');
      setClientsData(response.data);
    } catch (err) {
      setApiErrors(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Função para buscar relatório de atendentes
  const fetchAttendantsReport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.get('/relatorios/attendants', {
        params: {
          startDate: dateRange.start,
          endDate: dateRange.end,
        },
      });
      setAttendantsData(response.data);
    } catch (err) {
      setApiErrors(err);
    } finally {
      setIsLoading(false);
    }
  }, [dateRange]);

  // Função para buscar relatório de tickets
  const fetchTicketsReport = useCallback(
    async (endpoint, filters = {}) => {
      try {
        setIsLoading(true);
        const params = {
          startDate: dateRange.start,
          endDate: dateRange.end,
          status: statusFilter || undefined,
          ...filters,
        };

        const response = await axios.get(`/relatorios/${endpoint}`, { params });
        setTicketsData(response.data);
      } catch (err) {
        setApiErrors(err);
      } finally {
        setIsLoading(false);
      }
    },
    [dateRange, statusFilter]
  );

  // Função para buscar relatório de tickets unificado
  const fetchUnifiedTicketsReport = useCallback(async () => {
    try {
      setIsLoading(true);
      const params = {
        startDate: dateRange.start,
        endDate: dateRange.end,
        attendantId: selectedAttendant || undefined,
        departmentId: selectedDepartment || undefined,
        serviceDeskId: selectedServiceDesk || undefined,
        customerId: selectedCustomer || undefined,
        status: statusFilter || undefined,
      };

      const response = await axios.get('/relatorios/tickets-unified', {
        params,
      });
      setTicketsData(response.data);
    } catch (err) {
      setApiErrors(err);
    } finally {
      setIsLoading(false);
    }
  }, [
    dateRange,
    selectedAttendant,
    selectedDepartment,
    selectedServiceDesk,
    selectedCustomer,
    statusFilter,
  ]);

  // Função para controlar a alteração das datas
  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDateRange((prev) => ({ ...prev, [name]: value }));
  };

  // Função para formatar status dos tickets
  const formatStatus = (status) => {
    switch (status) {
      case 'aberto':
        return 'Aberto';
      case 'fechado':
        return 'Fechado';
      case 'em_atendimento':
        return 'Em Atendimento';
      case 'pausado':
        return 'Pausado';
      default:
        return status;
    }
  };

  // Função para calcular o SLA (Atendimento ou Solução)
  const calculateSLA = useCallback(
    (ticket, slaType) => {
      const { createdAt, startTime, closingTime } = ticket;
      const serviceDesk = serviceDesks.find(
        (desk) => desk.id === ticket.serviceDesk
      );
      const priority = serviceDesk.priorities.find(
        (p) => p.id === ticket.priority
      );
      const { atendimentoVencimento } = priority;
      const { solucaoVencimento } = priority;

      let slaAtraso = 'N/A';

      if (slaType === 'sla_atendimento') {
        // SLA de Atendimento
        const currentTime = moment();
        const createdTime = moment(createdAt);
        const deadline = createdTime
          .clone()
          .add(moment.duration(atendimentoVencimento));

        if (!startTime) {
          slaAtraso = currentTime.isAfter(deadline)
            ? `❌ Atrasado há ${deadline.fromNow(true)}`
            : `⏳ Vence em ${deadline.fromNow(true)}`;
        } else {
          const startMoment = moment(startTime);
          slaAtraso = startMoment.isAfter(deadline)
            ? `❌ SLA vencido (${startMoment.diff(deadline, 'hours', true).toFixed(2)}h)`
            : `✔️ SLA cumprido`;
        }
      } else if (slaType === 'sla_solucao') {
        // SLA de Solução
        if (!startTime) {
          slaAtraso = 'Não iniciado';
        } else {
          const startMoment = moment(startTime);
          const solutionDeadline = startMoment
            .clone()
            .add(moment.duration(solucaoVencimento));

          if (!closingTime) {
            slaAtraso = moment().isAfter(solutionDeadline)
              ? `❌ Atrasado há ${solutionDeadline.fromNow(true)}`
              : `⏳ Vence em ${solutionDeadline.fromNow(true)}`;
          } else {
            const closingMoment = moment(closingTime);
            const solutionDuration = closingMoment.diff(
              startMoment,
              'hours',
              true
            );
            slaAtraso =
              solutionDuration > moment.duration(solucaoVencimento).asHours()
                ? `❌ SLA vencido (${solutionDuration.toFixed(2)}h)`
                : `✔️ SLA cumprido (${solutionDuration.toFixed(2)}h)`;
          }
        }
      }

      return slaAtraso;
    },
    [serviceDesks]
  );

  // Função para obter dados do relatório
  const getReportData = useCallback(async () => {
    console.log('getReportData chamada com:', {
      filterType,
      dateRange,
      statusFilter,
      profilesCount: profiles.length,
      serviceDesksCount: serviceDesks.length,
    });

    try {
      setIsLoading(true);

      // Verificar se é um dos novos tipos de relatório
      if (filterType === 'clients-by-servicedesk') {
        await fetchClientsReport();
        return;
      }

      if (filterType === 'attendants-report') {
        await fetchAttendantsReport();
        return;
      }

      if (filterType === 'tickets-by-attendant') {
        await fetchTicketsReport('tickets-by-attendant', {
          attendantId: selectedAttendant || undefined,
        });
        return;
      }

      if (filterType === 'tickets-by-department') {
        await fetchTicketsReport('tickets-by-department', {
          departmentId: selectedDepartment || undefined,
        });
        return;
      }

      if (filterType === 'tickets-by-servicedesk') {
        await fetchTicketsReport('tickets-by-servicedesk', {
          serviceDeskId: selectedServiceDesk || undefined,
        });
        return;
      }

      // Relatório de Tickets Unificado
      if (filterType === 'tickets') {
        await fetchUnifiedTicketsReport();
        return;
      }

      // Lógica original para os relatórios existentes
      const dateField =
        filterType === 'encerrado' ? 'closingTime' : 'createdAt';

      const response = await axios.get(`/relatorios`, {
        params: {
          filterType,
          reportType,
          startDate: dateRange.start,
          endDate: dateRange.end,
          dateField, // Define o campo de data (createdAt ou closingTime)
          statusFilter: statusFilter || undefined, // Inclui o filtro de status apenas se não estiver vazio
        },
      });

      const mappedData = response.data
        .filter((ticket) => {
          // Adicionando a lógica para filtrar tickets por status
          if (statusFilter) {
            return ticket.status === statusFilter; // Aplica o filtro localmente
          }
          return true;
        })
        .map((ticket) => {
          // Usar dados que vêm diretamente do backend com associações
          const assignedToName =
            ticket.AssignedUser && ticket.AssignedUser.UserProfile
              ? `${ticket.AssignedUser.UserProfile.name} ${ticket.AssignedUser.UserProfile.lastname}`
              : 'Desconhecido';

          const departmentName = ticket.Department
            ? ticket.Department.name
            : 'Desconhecido';

          const serviceDeskName = ticket.ServiceDesk
            ? ticket.ServiceDesk.name
            : 'Desconhecido';

          // Usar dados de Stage diretamente das associações do backend
          const stageName = ticket.Stage ? ticket.Stage.name : 'Desconhecido';

          return {
            ...ticket,
            assignedTo: assignedToName,
            departmentName,
            serviceDeskName,
            stageName,
            formattedStatus: formatStatus(ticket.status),
            createdAt: moment(ticket.createdAt).format('DD/MM/YYYY HH:mm:ss'),
            startTime: ticket.startTime
              ? moment(ticket.startTime).format('DD/MM/YYYY HH:mm:ss')
              : 'Não iniciado',
            closingTime: ticket.closingTime
              ? moment(ticket.closingTime).format('DD/MM/YYYY HH:mm:ss')
              : 'Ainda aberto',
            sla: calculateSLA(ticket, filterType),
          };
        });

      // Agrupamento de dados conforme o tipo de filtro selecionado
      let groupedData;
      switch (filterType) {
        case 'atendentes':
          groupedData = Object.values(groupBy(mappedData, 'assignedTo'));
          break;
        case 'departamentos':
          groupedData = Object.values(groupBy(mappedData, 'departmentName'));
          break;
        case 'servicedesk':
          groupedData = Object.values(groupBy(mappedData, 'serviceDeskName'));
          break;
        case 'stageid':
          groupedData = Object.values(groupBy(mappedData, 'stageName'));
          break;
        case 'status':
          groupedData = Object.values(groupBy(mappedData, 'formattedStatus'));
          break;
        default:
          groupedData = mappedData;
      }

      const totalTickets = mappedData.length;
      groupedData = groupedData.map((group) => ({
        ...group,
        percentual: `${((group.total / totalTickets) * 100).toFixed(2)}%`,
      }));

      setData(groupedData);
    } catch (err) {
      console.error('Erro ao carregar dados do relatório:', err);
      console.error('Detalhes do erro:', {
        message: err.message,
        response: err.response ? err.response.data : null,
        status: err.response ? err.response.status : null,
        filterType,
        dateRange,
      });
      setApiErrors(err);
    } finally {
      setIsLoading(false);
    }
  }, [
    filterType,
    reportType,
    dateRange.start,
    dateRange.end,
    statusFilter,
    profiles,
    serviceDesks,
    calculateSLA,
    fetchAttendantsReport,
    fetchClientsReport,
    fetchTicketsReport,
    selectedAttendant,
    selectedDepartment,
    selectedServiceDesk,
    selectedCustomer,
  ]);

  // Função auxiliar para agrupar dados
  const groupBy = (array, key) => {
    return array.reduce((result, currentValue) => {
      const groupKey = currentValue[key] || 'Desconhecido';
      if (!result[groupKey]) {
        result[groupKey] = { key: groupKey, total: 0, tickets: [] };
      }
      result[groupKey].tickets.push(currentValue);
      result[groupKey].total += 1;
      return result;
    }, {});
  };

  useEffect(() => {
    fetchAuxiliaryData();
  }, [fetchAuxiliaryData]);

  useEffect(() => {
    // Limpar dados e resetar filtros quando o tipo de filtro muda
    setData([]);
    setClientsData([]);
    setAttendantsData([]);
    setTicketsData([]);

    // Redefine o statusFilter quando o filterType não precisar de status
    if (
      ![
        'atendentes',
        'departamentos',
        'servicedesk',
        'stageid',
        'tickets-by-attendant',
        'tickets-by-department',
        'tickets-by-servicedesk',
      ].includes(filterType)
    ) {
      setStatusFilter(''); // Reseta o filtro de status
    }

    // Resetar filtros específicos
    setSelectedAttendant('');
    setSelectedDepartment('');
    setSelectedServiceDesk('');
    setSelectedCustomer('');
  }, [filterType]);

  // Remover o useEffect que chama getReportData automaticamente
  // Os dados só devem ser carregados quando o usuário clicar em "Aplicar Filtros"

  const handleExport = () => {
    let exportData = data;
    let filename = 'Relatorio_Tickets';

    // Preparar dados específicos para cada tipo de relatório
    switch (filterType) {
      case 'clients-by-servicedesk':
        exportData = data.map((item) => ({
          'Mesa de Serviço': item.serviceDeskName,
          Descrição: item.serviceDeskDescription,
          'Total de Clientes': item.totalClients,
          Clientes: item.clients
            ? item.clients
                .map((c) => `${c.name} - ${c.email || 'N/A'}`)
                .join('; ')
            : 'Nenhum cliente',
        }));
        filename = 'Relatorio_Clientes_por_Mesa';
        break;

      case 'attendants-report':
        exportData = data.map((item) => ({
          Atendente: item.attendantName,
          Email: item.attendantEmail,
          'Total de Tickets': item.totalTickets,
          'Tickets Abertos': item.openTickets,
          'Tickets Fechados': item.closedTickets,
          'Tickets Pausados': item.pausedTickets,
          'Em Atendimento': item.inProgressTickets,
        }));
        filename = 'Relatorio_Atendentes';
        break;

      case 'tickets-by-attendant':
      case 'tickets-by-department':
      case 'tickets-by-servicedesk':
        exportData = data.map((item) => ({
          ID: item.id,
          Título: item.title,
          Status: item.status,
          Prioridade: item.priority,
          Cliente:
            item.customer && item.customer.razaoSocial
              ? item.customer.razaoSocial
              : 'N/A',
          Atendente:
            item.assignedUser && item.assignedUser.name
              ? item.assignedUser.name
              : 'N/A',
          'Mesa de Serviço':
            item.serviceDesk && item.serviceDesk.name
              ? item.serviceDesk.name
              : 'N/A',
          Departamento:
            item.department && item.department.name
              ? item.department.name
              : 'N/A',
          'Data de Criação': moment(item.createdAt).format('DD/MM/YYYY HH:mm'),
          'Data de Fechamento': item.closingTime
            ? moment(item.closingTime).format('DD/MM/YYYY HH:mm')
            : 'N/A',
        }));
        filename = `Relatorio_Tickets_${filterType.replace('tickets-by-', '')}`;
        break;

      case 'tickets':
        exportData = ticketsData.map((item) => ({
          N_Ticket: item.id,
          Atendente: item.assignedUser ? item.assignedUser.name : 'N/A',
          DATA_CRIACAO: item.createdAt
            ? moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss')
            : 'N/A',
          INICIO_ATENDIMENTO: item.startTime
            ? moment(item.startTime).format('DD/MM/YYYY HH:mm:ss')
            : 'Não iniciado',
          FIM_ATENDIMENTO: item.closingTime
            ? moment(item.closingTime).format('DD/MM/YYYY HH:mm:ss')
            : 'Ainda aberto',
          STATUS_TICKET: item.status,
          SOLICITANTE: item.requester ? item.requester.name : 'N/A',
          FILA_ATENDIMENTO: item.serviceDesk ? item.serviceDesk.name : 'N/A',
          CLIENTE: item.customer ? item.customer.name : 'N/A',
          TITULO: item.title,
        }));
        filename = 'Relatorio_Tickets';
        break;

      default:
        // Para relatórios existentes, manter o comportamento atual
        break;
    }

    exportToExcel(exportData, filename);
  };

  // Função para obter os dados corretos baseado no tipo de filtro
  const getDataForTable = () => {
    switch (filterType) {
      case 'clients-by-servicedesk':
        return clientsData;
      case 'attendants-report':
        return attendantsData;
      case 'tickets':
      case 'tickets-by-attendant':
      case 'tickets-by-department':
      case 'tickets-by-servicedesk':
        return ticketsData;
      default:
        return data;
    }
  };

  return (
    <Container fluid>
      <Breadcrumbs title="Relatórios" />
      <PageHeader title="Carga de Trabalho" />
      <Loading isLoading={isLoading} />
      <ErrorProcessor error={apiErrors} />

      <Row>
        <Col lg={12} className="mb-4">
          <Card>
            <Card.Body>
              <Row className="mb-3">
                <Col className="d-flex justify-content-between align-items-center">
                  <div>
                    <strong>Filtros Ativos:</strong>
                    <span className="ms-2">
                      {dateRange.start && dateRange.end
                        ? `${dateRange.start} até ${dateRange.end}`
                        : 'Período não definido'}
                      {filterType &&
                        ` | Tipo: ${getFilterTypeLabel(filterType)}`}
                      {statusFilter && ` | Status: ${statusFilter}`}
                    </span>
                  </div>
                  <Button
                    variant="outline-primary"
                    onClick={() => setShowFilterModal(true)}
                  >
                    <i className="fas fa-filter me-2" />
                    Configurar Filtros
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Modal de Filtros */}
      <Modal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Configurar Filtros de Relatório</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Período */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="startDate">
                  <Form.Label>Data de início</Form.Label>
                  <Form.Control
                    type="date"
                    name="start"
                    value={dateRange.start}
                    onChange={handleDateChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="endDate">
                  <Form.Label>Data de fim</Form.Label>
                  <Form.Control
                    type="date"
                    name="end"
                    value={dateRange.end}
                    onChange={handleDateChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Tipo de Relatório */}
            <Row className="mb-3">
              <Col>
                <Form.Group controlId="filterType">
                  <Form.Label>Tipo de Relatório</Form.Label>
                  <Form.Control
                    as="select"
                    value={filterType}
                    onChange={(e) => setFilterType(e.target.value)}
                  >
                    <option value="tickets">Relatório de Tickets</option>
                    <option value="status">Status</option>
                    <option value="stageid">Estágios</option>
                    <option value="sla_atendimento">
                      SLA Atrasado (Atendimento)
                    </option>
                    <option value="sla_solucao">SLA Atrasado (Solução)</option>
                    <option value="encerrado">Tickets Encerrados</option>
                    <option value="clients-by-servicedesk">
                      Clientes por Mesa de Serviço
                    </option>
                    <option value="attendants-report">
                      Relatório de Atendentes
                    </option>
                    <option value="tickets-by-attendant">
                      Tickets por Atendente
                    </option>
                    <option value="tickets-by-department">
                      Tickets por Departamento
                    </option>
                    <option value="tickets-by-servicedesk">
                      Tickets por Mesa de Serviço
                    </option>
                    <option value="unified-tickets">
                      📊 Relatório Unificado de Tickets
                    </option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            {/* Filtros Específicos para Relatório de Tickets */}
            {filterType === 'tickets' && (
              <>
                <Row className="mb-3">
                  <Col md={3}>
                    <Form.Group controlId="selectedCustomer">
                      <Form.Label>Cliente</Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedCustomer}
                        onChange={(e) => setSelectedCustomer(e.target.value)}
                      >
                        <option value="">Todos os clientes</option>
                        {customers.map((customer) => (
                          <option key={customer.id} value={customer.id}>
                            {customer.nomeEmpresa ||
                              customer.razaoSocial ||
                              customer.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group controlId="selectedAttendant">
                      <Form.Label>Atendente</Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedAttendant}
                        onChange={(e) => setSelectedAttendant(e.target.value)}
                      >
                        <option value="">Todos os atendentes</option>
                        {profiles.map((profile) => (
                          <option key={profile.user_id} value={profile.user_id}>
                            {profile.name} {profile.lastname}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group controlId="selectedDepartment">
                      <Form.Label>Departamento</Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedDepartment}
                        onChange={(e) => setSelectedDepartment(e.target.value)}
                      >
                        <option value="">Todos os departamentos</option>
                        {departments.map((dept) => (
                          <option key={dept.id} value={dept.id}>
                            {dept.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group controlId="selectedServiceDesk">
                      <Form.Label>Mesa de Serviço</Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedServiceDesk}
                        onChange={(e) => setSelectedServiceDesk(e.target.value)}
                      >
                        <option value="">Todas as mesas</option>
                        {serviceDesks.map((desk) => (
                          <option key={desk.id} value={desk.id}>
                            {desk.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={3}>
                    <Form.Group controlId="statusFilter">
                      <Form.Label>Status</Form.Label>
                      <Form.Control
                        as="select"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        <option value="">Todos</option>
                        <option value="aberto">Aberto</option>
                        <option value="fechado">Fechado</option>
                        <option value="em_atendimento">Em Atendimento</option>
                        <option value="pausado">Pausado</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            {/* Status */}
            {[
              'atendentes',
              'departamentos',
              'servicedesk',
              'stageid',
              'tickets-by-attendant',
              'tickets-by-department',
              'tickets-by-servicedesk',
            ].includes(filterType) && (
              <Row className="mb-3">
                <Col>
                  <Form.Group controlId="status">
                    <Form.Label>Status</Form.Label>
                    <Form.Control
                      as="select"
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                    >
                      <option value="">Todos</option>
                      <option value="aberto">Aberto</option>
                      <option value="fechado">Fechado</option>
                      <option value="em_atendimento">Em Atendimento</option>
                      <option value="pausado">Pausado</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilterModal(false)}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={async () => {
              setShowFilterModal(false);
              // Aguardar um pouco para o modal fechar antes de carregar os dados
              setTimeout(() => {
                getReportData();
              }, 100);
            }}
          >
            Aplicar Filtros e Exibir
          </Button>
        </Modal.Footer>
      </Modal>

      <Row>
        <Col lg={12} className="mb-4">
          <Card className="card-table">
            <Card.Body>
              <Row className="mb-4">
                {/* <Col md={9}>
                  <h4>{`Total: ${data.length} Registros`}</h4>
                </Col> */}
                <Col md={3} className="text-right">
                  <Button variant="success" onClick={handleExport}>
                    <FaDownload /> Download XLSX
                  </Button>
                </Col>
              </Row>
              <DataTable
                items={getDataForTable()}
                columns={generateColumns(filterType)}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

function generateColumns(filterType) {
  if (filterType === 'sla_atendimento') {
    return [
      { Header: 'Ticket', accessor: 'id' },
      { Header: 'Data Criação', accessor: 'createdAt' },
      { Header: 'Data de Início', accessor: 'startTime' },
      { Header: 'SLA Atraso', accessor: 'sla' },
      {
        Header: 'Ações',
        accessor: 'actions',
        Cell: ({ row }) => (
          <Button
            variant="primary"
            onClick={() =>
              (window.location.href = `/tickets/${row.original.id}/edit`)
            }
          >
            Ver
          </Button>
        ),
      },
    ];
  }
  if (filterType === 'sla_solucao') {
    return [
      { Header: 'Ticket', accessor: 'id' },
      { Header: 'Início do atendimento', accessor: 'startTime' },
      { Header: 'Solução do atendimento', accessor: 'closingTime' },
      { Header: 'SLA Atraso', accessor: 'sla' },
      {
        Header: 'Ações',
        accessor: 'actions',
        Cell: ({ row }) => (
          <Button
            variant="primary"
            onClick={() =>
              (window.location.href = `/tickets/${row.original.id}/edit`)
            }
          >
            Ver
          </Button>
        ),
      },
    ];
  }
  if (filterType === 'encerrado') {
    // Colunas para o filtro "Tickets Encerrados"
    return [
      { Header: 'Ticket', accessor: 'id' },
      { Header: 'Data Criação', accessor: 'createdAt' },
      { Header: 'Data de Encerramento', accessor: 'closingTime' },
      {
        Header: 'Ações',
        accessor: 'actions',
        Cell: ({ row }) => (
          <Button
            variant="primary"
            onClick={() =>
              (window.location.href = `/tickets/${row.original.id}/edit`)
            }
          >
            Ver
          </Button>
        ),
      },
    ];
  }
  // Outras colunas padrão para os filtros já existentes
  switch (filterType) {
    case 'atendentes':
      return [
        { Header: 'Atendente', accessor: 'key' },
        { Header: 'Tickets', accessor: 'total' },
        { Header: 'Percentual', accessor: 'percentual' },
      ];
    case 'departamentos':
      return [
        { Header: 'Departamento', accessor: 'key' },
        { Header: 'Tickets', accessor: 'total' },
        { Header: 'Percentual', accessor: 'percentual' },
      ];
    case 'servicedesk':
      return [
        { Header: 'Mesa de Serviço', accessor: 'key' },
        { Header: 'Tickets', accessor: 'total' },
        { Header: 'Percentual', accessor: 'percentual' },
      ];
    case 'stageid':
      return [
        { Header: 'Estágio', accessor: 'key' },
        { Header: 'Tickets', accessor: 'total' },
        { Header: 'Percentual', accessor: 'percentual' },
      ];
    case 'status':
      return [
        { Header: 'Status', accessor: 'key' },
        { Header: 'Tickets', accessor: 'total' },
        { Header: 'Percentual', accessor: 'percentual' },
      ];
    case 'clients-by-servicedesk':
      return [
        { Header: 'Mesa de Serviço', accessor: 'serviceDeskName' },
        { Header: 'Descrição', accessor: 'serviceDeskDescription' },
        { Header: 'Total de Clientes', accessor: 'totalClients' },
        {
          Header: 'Clientes',
          accessor: 'clients',
          Cell: ({ value }) => (
            <div>
              {value && value.length > 0 ? (
                <ul style={{ margin: 0, paddingLeft: '20px' }}>
                  {value.slice(0, 3).map((client, index) => (
                    <li key={index}>
                      {client.name} - {client.email || 'N/A'}
                    </li>
                  ))}
                  {value.length > 3 && <li>... e mais {value.length - 3}</li>}
                </ul>
              ) : (
                'Nenhum cliente'
              )}
            </div>
          ),
        },
      ];
    case 'attendants-report':
      return [
        { Header: 'Atendente', accessor: 'attendantName' },
        { Header: 'Email', accessor: 'attendantEmail' },
        { Header: 'Total de Tickets', accessor: 'totalTickets' },
        { Header: 'Tickets Abertos', accessor: 'openTickets' },
        { Header: 'Tickets Fechados', accessor: 'closedTickets' },
        { Header: 'Tickets Pausados', accessor: 'pausedTickets' },
        { Header: 'Em Atendimento', accessor: 'inProgressTickets' },
      ];
    case 'tickets-by-attendant':
    case 'tickets-by-department':
    case 'tickets-by-servicedesk':
      return [
        { Header: 'ID', accessor: 'id' },
        { Header: 'Título', accessor: 'title' },
        { Header: 'Status', accessor: 'status' },
        { Header: 'Prioridade', accessor: 'priority' },
        { Header: 'Cliente', accessor: 'Customer.razaoSocial' },
        { Header: 'Atendente', accessor: 'AssignedUser.name' },
        { Header: 'Mesa de Serviço', accessor: 'ServiceDesk.name' },
        { Header: 'Departamento', accessor: 'Department.name' },
        {
          Header: 'Data de Criação',
          accessor: 'createdAt',
          Cell: ({ value }) => moment(value).format('DD/MM/YYYY HH:mm'),
        },
        {
          Header: 'Data de Fechamento',
          accessor: 'closingTime',
          Cell: ({ value }) =>
            value ? moment(value).format('DD/MM/YYYY HH:mm') : 'N/A',
        },
        {
          Header: 'Ações',
          accessor: 'actions',
          Cell: ({ row }) => (
            <Button
              variant="primary"
              size="sm"
              onClick={() =>
                (window.location.href = `/tickets/${row.original.id}/edit`)
              }
            >
              Ver
            </Button>
          ),
        },
      ];
    case 'tickets':
      return [
        {
          Header: 'N° Ticket',
          accessor: 'id',
          Cell: ({ value }) => (
            <a
              href={`/tickets/${value}/edit`}
              style={{
                color: '#007bff',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onClick={(e) => {
                e.preventDefault();
                window.location.href = `/tickets/${value}/edit`;
              }}
            >
              {value}
            </a>
          ),
        },
        { Header: 'Título', accessor: 'title' },
        { Header: 'Status', accessor: 'status' },
        { Header: 'Cliente', accessor: 'customer.name' },
        { Header: 'Solicitante', accessor: 'requester.name' },
        { Header: 'Atendente', accessor: 'assignedUser.name' },
        { Header: 'Fila (Mesa de Serviço)', accessor: 'serviceDesk.name' },
        { Header: 'Departamento', accessor: 'department.name' },
        {
          Header: 'Data de Criação',
          accessor: 'createdAt',
          Cell: ({ value }) =>
            value ? moment(value).format('DD/MM/YYYY HH:mm') : 'N/A',
        },
        {
          Header: 'Início Atendimento',
          accessor: 'startTime',
          Cell: ({ value }) =>
            value ? moment(value).format('DD/MM/YYYY HH:mm') : 'Não iniciado',
        },
        {
          Header: 'Fechamento',
          accessor: 'closingTime',
          Cell: ({ value }) =>
            value ? moment(value).format('DD/MM/YYYY HH:mm') : 'Ainda aberto',
        },
      ];
    default:
      return [];
  }
}
